import _ from 'lodash'
import moment from 'moment'



let myFunctions = {
	version : "v11.17",
	host_url : "/secondlayerstable/",
	maskId : function(id){
		if(_.size(id) >= 10){
			let last_4_digits = id.substring( id.length - 4);
			let first_6_digits = '******';
			let mask_id = first_6_digits + last_4_digits;
			return mask_id;
		}else{
			return id;
		}
	},
	getDay : function(date){
		let dayNumber = moment(date, "YYYYMMDD").day();
		let dayChinese = "";
		if(dayNumber===0){
		  dayChinese = "日"
		}else if(dayNumber===1){
		  dayChinese = "一"
		}else if(dayNumber===2){
		  dayChinese = "二"
		}else if(dayNumber===3){
		  dayChinese = "三"
		}else if(dayNumber===4){
		  dayChinese = "四"
		}else if(dayNumber===5){
		  dayChinese = "五"
		}else if(dayNumber===6){
		  dayChinese = "六"
		}
		return dayChinese;		
	},
	getReadableTimsS : function(TimeS){
		if(_.size(TimeS)!==4){
			return TimeS;
		}

		let hr = TimeS.substring(0,2);
		let min = TimeS.substring(2,4);
		return hr+":"+min;		
	},
	getReadableDate : function(date){
		if(_.size(date)!==8){
			return date;
		}

		let yr = date.substring(0,4);
		let month = date.substring(4,6);
		let day = date.substring(6,8);
		return yr + "/" + month + "/" + day;		
	}





}
export default myFunctions



// WEBPACK FOOTER //
// ./src/stores/myFunctions.js